import ApplicationIntro from './ApplicationIntro';

export default ApplicationIntro;
